/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, percent: NonNullable<unknown> }} Report_Partner_UntieredInputs */



/**
* | output |
* | --- |
* | "Partner: {name} · {percent} off list on seats and copilot; the tier was not recorded for this period · net amounts" |
*
* @param {Report_Partner_UntieredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_partner_untiered = /** @type {((inputs: Report_Partner_UntieredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Partner_UntieredInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Partner: ${i?.name} · ${i?.percent} unter Liste auf Plätze und Copilot; die Stufe wurde für diesen Zeitraum nicht erfasst · Nettobeträge`)
	return /** @type {LocalizedString} */ (`Partner: ${i?.name} · ${i?.percent} off list on seats and copilot; the tier was not recorded for this period · net amounts`)
});